import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'resizeImage' })
export class ResizeImagePipe implements PipeTransform {
  private readonly availableDomains = [
    'akebono.world',
    'twilight.link',
    'ecarjp.com',
    'lots-staging.link',
  ];

  transform(imageUrl: string, size: [number, number]): string {
    if (this.isAvailableImageDomain(imageUrl)) {
      const [width, height] = size;
      return this.resizeImage(imageUrl, width, height);
    } else {
      return imageUrl;
    }
  }

  private resizeImage(imageUrl: string, width: number, height: number): string {
    const originalUrl = new URL(imageUrl);
    const pathSegments = this.getPathSegments(originalUrl);
    const clearPathSegments = this.removeExistingResize(pathSegments);
    const resizedPathSegments = this.pushSizeToSegments(clearPathSegments, width, height);
    const newImageUrl = this.buildFullUrl(originalUrl, resizedPathSegments);

    return newImageUrl;
  }

  private buildFullUrl(originalUrl: URL, pathSegments: string[]): string {
    const newUrl = new URL(originalUrl.href);

    newUrl.pathname = `/${pathSegments.join('/')}`;

    return newUrl.href;
  }

  private pushSizeToSegments(pathSegments: string[], width: number, height: number): string[] {
    const sizeString = `${width}x${height}`;
    pathSegments = [...pathSegments];

    if (pathSegments[0] === 'pp' || pathSegments[0] === 'qp') {
      pathSegments.splice(1, 0, sizeString);
    } else {
      pathSegments.unshift(sizeString);
    }

    return pathSegments;
  }

  private getPathSegments(url: URL): string[] {
    return url.pathname.replace(/^\/+/, '').split('/');
  }

  private removeExistingResize(pathSegments: string[]): string[] {
    const sizeRegExp = /^\d+x\d+$/;
    return pathSegments.filter((segment) => !sizeRegExp.test(segment));
  }

  private isAvailableImageDomain(imageUrl: string): boolean {
    return this.availableDomains.some((domain) => imageUrl.includes(domain));
  }
}
